export default __webpack_public_path__ + "static/media/025-speed limit.347d7255.png";